import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../site_manage';

export default function Launcher(props) {
  const config = useDialogConfig();

  const site = useConnect('site.byId', {
    id: config.params.siteId
  });

  if (site.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      site={site}
      onClose={props.onClose}
    />
  );
};
